/**
 * Outlined exclamation icon with no fill and configurable dimensions.
 *
 * @param props.width - SVG width (defaults to `24`).
 * @param props.height - SVG height (defaults to `24`).
 * @param props.strokeColor - Outline color (defaults to red `#FF0000`).
 * @returns The rendered outlined exclamation SVG icon.
 */
const ExclamationWithoutFill = ({
  width = "24",
  height = "24",
  strokeColor = "#FF0000",
}: {
  width?: string;
  height?: string;
  strokeColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={strokeColor}
    strokeWidth="1.5"
    strokeLinecap="round"
  >
    <ellipse cx="12" cy="12" rx="10.9" ry="11.25" />
    <path d="M12 6.75V13.25" />
    <circle cx="12" cy="16" r="0.5" />
  </svg>
);

export default ExclamationWithoutFill;
